import React, {createContext, useContext, useState} from "react";
import {ServiceDetailRepository} from "../../repository/AdminDashboard/DeviceServisce_Repository";
import {ServiceModalData} from '../../repository/AdminDashboard/DeviceServisce_Repository'
import {useNavigate} from "react-router-dom";
import toast, {Toaster} from "react-hot-toast";

const StateContext = createContext();
const initialState = {};
const ServiceDetailContext = ({children}) => {
    const navigate = useNavigate();
    const [loaded, setloaded] = useState(false);
    const [ServiceNumber, setServiceNumber] = useState("");
    const [SerialNumber, setSerialNumber] = useState("");
    const [timeDate, settimeDate] = useState("");
    const [nameOwner, setnameOwner] = useState("");
    const [numberOwner, setnumberOwner] = useState("");
    const [service, setservice] = useState("");
    const [detailtext, setdetailtext] = useState("");
    const [showDeleteModal, setshowDeleteModal] = useState(false);
    const [showModal, setshowModal] = useState(false);
    const [id, setid] = useState("");

    const getDetail = async (id) => {
        setloaded(true);
        const data = await ServiceDetailRepository.getDetail(id);
        setid(data.id);
        setServiceNumber(data.serviceNumber);
        setSerialNumber(data.serialNumber);
        settimeDate(data.dateTime);
        setnameOwner(data.nameOwner);
        setnumberOwner(data.numberOwner);
        setservice(data.service);
        setdetailtext(data.TextDetail);
        setloaded(false);
    };

    // const edit
    const sendEdit = async (data) => {

        const response = await ServiceModalData.editservice(data)
        if (!response.success) {
            toast.error(response.message, {
                className: "text-12 text-dark-blue-200",
            });
            return;

        }
        toast.success(response.message, {
            className: "text-12 text-dark-blue-200",
        });
        setshowModal(false)
        await getDetail(id)


    }

    // delete
    const deleteDeviceService = async () => {
        const data = await ServiceDetailRepository.delete(id);
        if (data.code == 1) {
            navigate("/admin/device/Service/");
            // console.log(data.massage)
            setTimeout(() => {
                toast.success(data.massage, {
                    className: "text-12 text-dark-blue-200",
                });
            }, 1000);
        } else if (data.code == 0) {
            toast.error(data.massage, {
                className: "text-12 text-dark-blue-200",
            });
        }
    };

    // ondelete device
    const deleteService = () => {
        setshowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setshowDeleteModal(false);
    };

    const RemoveItem = async () => {
        setshowDeleteModal(false);
        await deleteDeviceService(id);
    };

    // edit

    const editService = (event) => {
        // console.log("call")
        // const id = event.currentTarget.getAttribute("data-attr");
        // setid(id);
        // await getedit(id);
        setshowModal(true);
    };
    const closeModal = () => {
        setshowModal(false);


    };
    const doneedit = async () => {
        const data = {
            id: id,
            text: detailtext,
            serviceType: service
        }
        await sendEdit(data)
    }
    const onchangeTextArea = (event) => {
        // console.log(event.target.value)
        setdetailtext(event.target.value);


    };
    const onchangeTypeService = (event) => {
        if (event.length > 0) {
            setservice(event[0].value);

        }
    };
    return (
        <StateContext.Provider
            value={{
                loaded,
                ServiceNumber,
                editService,
                deleteService,
                SerialNumber,
                timeDate,
                detailtext,
                service,
                numberOwner,
                nameOwner,
                getDetail,
                closeDeleteModal,
                showDeleteModal,
                RemoveItem,

                showModal,
                closeModal,
                doneedit,
                onchangeTextArea,
                onchangeTypeService
            }}>
            {children}
        </StateContext.Provider>
    );
};

function ServiceDetailUseContext() {
    return React.useContext(StateContext);
}

export default ServiceDetailContext;
export {ServiceDetailUseContext};
